<template>
  <div class="py-4 container-fluid">
    <div class="text-end mb-2">
      <span class="text-white">{{ timestamp }}</span>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="row">
          <div class="col-lg-4 col-md-6 col-12">
            <router-link to="/purchase-order">
              <card
                title="Purchase Order"
                :value="po_amount"
                iconClass="ni ni-credit-card"
                iconBackground="bg-gradient-success"
                directionReverse
              ></card>
            </router-link>
          </div>
          <div class="col-lg-4 col-md-6 col-12">
            <router-link to="/request-for-proposal">
              <card
                title="Request For Proposal"
                :value="tender_amount"
                iconClass="fa fa-rss"
                iconBackground="bg-gradient-info"
                directionReverse
              ></card>
            </router-link>
          </div>
          <div class="col-lg-4 col-md-6 col-12">
            <router-link to="/vendor-bill">
              <card
                title="Vendor Bills"
                :value="bill_amount"
                :percentage="'Paid : ' + bill_amount_pay"
                :detail="'Due : ' + bill_amount_residual"
                iconClass="fa fa-file-invoice"
                iconBackground="bg-gradient-primary"
                directionReverse
              ></card>
            </router-link>
          </div>
        </div>
        <!-- <div class="row">
          <div class="col-lg mb-lg">
            <div class="card z-index-2">
              <gradient-line-chart />
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import Card from "@/examples/Cards/Card.vue";
// import GradientLineChart from "@/examples/Charts/GradientLineChart.vue";
// import ArgonBadge from "@/components/ArgonBadge.vue";
// import EmptyState from "./components/EmptyState.vue";
const endpoint = require("../router/endpoint");

export default {
  name: "dashboard-default",
  data() {
    return {
      po_amount: "Rp 0",
      rfq_amount: "Rp 0",
      bill_amount: "Rp 0",
      bill_amount_pay: "Rp 0",
      bill_amount_residual: "Rp 0",
      tender_amount: "Rp 0",
      qpr_list: [],
      forecast: [],
      delivery: [],
      kanban: [],
      loading: false,
      timestamp: null
    };
  },
  components: {
    Card,
    // EmptyState,
    // GradientLineChart,
    // ArgonBadge
  },
  methods: {
    getPO() {
      this.po_list = [];
      this.axios
        .post(
          endpoint.DASHBOARD_PURCHASE,
          {
            partner_id: parseInt(localStorage.getItem("partner_id")),
            limit: 1000,
            offset: 0
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`
            }
          }
        )
        .then((response) => {
          if (response.data.msg_status === "0002"){
                    this.$notify({
                        type: 'warn',
                        title: 'Expired',
                        text: 'Session expired, please sign in again.',
                    });
                    this.$router.replace('/signin')
                    return false
          } else if (response.data.response_code === "0000") {
            this.po_amount = response.data.data[0].amount_total;
          } else {
            if (response.data.response_code !== "4000") {
              this.$notify({
                type: "error",
                title: "Warning",
                text: response.data.message
              });
            }
          }
          this.loading = false;
        })
        .catch((e) => {
          this.$notify({
            type: "error",
            title: "Error",
            text: e.response.data.message
          });
          this.loading = false;
        });
    },
    getBill() {
      this.axios
        .post(
          endpoint.DASHBOARD_BILL,
          {
            partner_id: parseInt(localStorage.getItem("partner_id")),
            limit: 1000,
            offset: 0
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`
            }
          }
        )
        .then((response) => {
          if (response.data.msg_status === "0002"){
            this.$notify({
                type: 'warn',
                title: 'Expired',
                text: 'Session expired, please sign in again.',
            });
            this.$router.replace('/signin')
            return false
          } else if (response.data.response_code === "0000") {
            this.bill_amount = response.data.data[0].amount_total;
            this.bill_amount_pay = response.data.data[0].amount_pay;
            this.bill_amount_residual = response.data.data[0].amount_residual;
          } else {
            if (response.data.response_code !== "4000") {
              this.$notify({
                type: "error",
                title: "Warning",
                text: response.data.message
              });
            }
            this.loading = false;
          }
        })
        .catch((e) => {
          this.$notify({
            type: "error",
            title: "Error",
            text: e.response.data.message
          });
          this.loading = false;
        });
    },
    getTender() {
      this.axios
        .post(
          endpoint.DASHBOARD_TENDER,
          {
            partner_id: parseInt(localStorage.getItem("partner_id")),
            limit: 1000,
            offset: 0
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`
            }
          }
        )
        .then((response) => {
          if (response.data.msg_status === "0002"){
            this.$notify({
                type: 'warn',
                title: 'Expired',
                text: 'Session expired, please sign in again.',
            });
            this.$router.replace('/signin')
            return false
          } else if (response.data.response_code === "0000") {
            this.tender_amount = response.data.data[0].format_currency;
          } else {
            if (response.data.response_code !== "4000") {
              this.$notify({
                type: "error",
                title: "Warning",
                text: response.data.message
              });
            }
            this.loading = false;
          }
        })
        .catch((e) => {
          this.$notify({
            type: "error",
            title: "Error",
            text: e.response.data.message
          });
          this.loading = false;
        });
    },
    getNow: function() {
        const today = new Date();
        const date = today.toLocaleString('en-us',{month:'long', year:'numeric', day:'numeric'})
        const time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
        const dateTime = date +' '+ time;
        this.timestamp = dateTime;
    }
  },
  created() {
      setInterval(this.getNow, 1000);
  },
  mounted() {
    this.getPO();
    this.getBill();
    this.getTender();
  }
};
</script>
